export const TRACKING_SCHEMA_VERSION = '2026-06-20';

export const TRACKING_SCHEMAS = Object.freeze({
  'lead.created': {
    required: ['leadId', 'source'],
    allowed: {
      source: [
        'portal_olx',
        'portal_zap',
        'portal_vivareal',
        'site',
        'whatsapp',
        'manual',
      ],
    },
    essential: true,
  },
  'visit.scheduled': {
    required: ['visitId', 'listingId', 'scheduledAt'],
    essential: true,
  },
  'visit.confirmed': {
    required: ['visitId'],
    essential: true,
  },
  'offer.sent': {
    required: ['offerId', 'listingId', 'amount'],
    essential: true,
  },
  'listing.published': {
    required: ['listingId', 'portal'],
    allowed: {
      portal: ['olx', 'zap', 'vivareal', 'imudei', 'site'],
    },
    essential: true,
  },
  'listing.lead_received': {
    required: ['listingId', 'portal'],
    allowed: {
      portal: ['olx', 'zap', 'vivareal', 'imudei', 'site'],
    },
    essential: true,
  },
  'listing.clicked': {
    required: ['listingId'],
    essential: false,
  },
  'listing.viewed': {
    required: ['listingId'],
    essential: false,
  },
  'listing.card_viewed': {
    required: ['listingId'],
    essential: false,
  },
  'listing.share_clicked': {
    required: ['listingId'],
    essential: false,
  },
  'listing.carousel_changed': {
    required: ['listingId'],
    essential: false,
  },
  'listing.alert_center_clicked': {
    required: [],
    essential: false,
  },
  'listing.quick_filter_clicked': {
    required: ['filter'],
    essential: false,
  },
  'page.viewed': {
    required: ['name', 'path'],
    essential: false,
  },
  lais_target_set: {
    required: ['scope', 'metric', 'periodType', 'periodStart', 'targetValue'],
    allowed: {
      scope: ['agent', 'team'],
    },
    essential: false,
  },
  lais_target_bulk_applied: {
    required: ['teamId', 'metric', 'periodType', 'periodStart', 'targetValue'],
    essential: false,
  },
  lais_target_reset_to_default: {
    required: ['scope', 'metric', 'periodType', 'periodStart'],
    allowed: {
      scope: ['agent', 'team'],
    },
    essential: false,
  },
  'search.performed': {
    required: ['query'],
    essential: false,
  },
  'favorite.toggled': {
    required: ['listingId', 'status'],
    allowed: {
      status: [true, false, 'true', 'false'],
    },
    essential: false,
  },
});

const isPresent = value => value === false || Boolean(value);

export const schemaFor = eventName => TRACKING_SCHEMAS[eventName] || null;

export const isEssentialTrackingEvent = eventName =>
  Boolean(schemaFor(eventName)?.essential);

export const validateTrackingSchema = (eventName, properties = {}) => {
  const schema = schemaFor(eventName);
  if (!schema) return true;

  const missing = schema.required.filter(key => !isPresent(properties[key]));
  if (missing.length) {
    throw new Error(`${eventName} requires: ${missing.join(', ')}`);
  }

  Object.entries(schema.allowed || {}).forEach(([key, allowedValues]) => {
    if (!Object.prototype.hasOwnProperty.call(properties, key)) return;
    if (allowedValues.includes(properties[key])) return;

    throw new Error(`${eventName} has invalid ${key}: ${properties[key]}`);
  });

  return true;
};

export const createTrackingEvent = (eventName, properties = {}) => {
  validateTrackingSchema(eventName, properties);

  return {
    event: eventName,
    schemaVersion: TRACKING_SCHEMA_VERSION,
    essential: isEssentialTrackingEvent(eventName),
    properties: {
      schemaVersion: TRACKING_SCHEMA_VERSION,
      ...properties,
    },
  };
};

export default TRACKING_SCHEMAS;
